import { Box, Card, CardContent, Divider } from '@mui/material'
import HistoryItemField from '@component/HistoryItemField'
import { Looks3Rounded } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { ColumnInput } from '@core/const'
import { ColumnResponse } from '@core/query'
import AreaUnit from '@component/AreaUnit'

export interface ColumnHistory extends ColumnInput {
  type: 'Column',
  result: ColumnResponse
}

interface Props {
  history: ColumnHistory
}

function ColumnHistoryItem ({ history }: Props) {
  const { t } = useTranslation()

  const srcResult = `${(+history.result.criterionSize).toFixed(0)} x ${(+history.result.calculatedSize).toFixed(0)}`
  const rcResult = `${(+history.result.criterionSize).toFixed(0)} x ${(+history.result.calculatedSizeForLateral).toFixed(0)}`

  return (
    <Card>
      <CardContent className="flex gap-16 !py-8">
        <Looks3Rounded />
        <Box className="relative">
          <Box className="grid grid-cols-2 gap-8 min-w-[16rem] overflow-auto">
            <HistoryItemField
              label={t('GLOSSARY.LONGSIDE_SPAN')}
              unit="m"
              value={history.longSideSpan}
            />
            <HistoryItemField
              label={t('GLOSSARY.SHORTSIDE_SPAN')}
              unit="m"
              value={history.shortSideSpan}
            />
            <HistoryItemField
              label={t('WORD.USAGE')}
              value={t(`GLOSSARY.USAGE.${history.usage}`)}
            />
            <HistoryItemField
              label={t('GLOSSARY.SLAB_THICKNESS')}
              value={history.slabThickness}
            />
            <HistoryItemField
              label={t('WORD.STORIES')}
              value={history.stories}
            />
            <HistoryItemField
              label={t('GLOSSARY.CONCRETE_STRENGTH')}
              unit="MPa"
              value={history.concreteStrength}
            />
            <HistoryItemField
              label={t('GLOSSARY.CRITERION_SIZE')}
              unit="mm"
              value={history.criterionSize}
            />
          </Box>
        </Box>
        <Box>
          <Divider orientation="vertical" />
        </Box>
        <Box className="flex flex-col gap-8">
          <HistoryItemField
            label={t('GLOSSARY.MIN_REQUIRED_AREA')}
            unit={<AreaUnit />}
            value={srcResult}
          />
          <HistoryItemField
            label={t('GLOSSARY.MIN_REQUIRED_CIRCLE_DIAMETER')}
            unit="mm"
            value={history.result.needDiameterForCircle.toFixed(0)}
          />
          <HistoryItemField
            label={t('GLOSSARY.MIN_REQUIRED_LATERAL_AREA')}
            unit={<AreaUnit />}
            value={rcResult}
          />
        </Box>
      </CardContent>
    </Card>
  )
}

export default ColumnHistoryItem
